import React, { useState, useEffect } from 'react';
import { useScrollNavigation } from '@/hooks/useScrollNavigation';
import { FlickeringGrid } from '@/components/ui/flickering-grid';
import { useIsMobile } from '@/hooks/use-mobile';

interface PageWrapperProps {
  children: React.ReactNode;
}

export const PageWrapper: React.FC<PageWrapperProps> = ({ children }) => {
  useScrollNavigation();
  const isMobile = useIsMobile();
  const [showGrid, setShowGrid] = useState(false);
  
  useEffect(() => {
    // Defer decorative grid rendering until after initial paint to improve TTI
    if (!isMobile) {
      const timeoutId = setTimeout(() => {
        // Use requestIdleCallback for better performance, with setTimeout fallback
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => {
            setShowGrid(true);
          }, { timeout: 1000 });
        } else {
          setTimeout(() => setShowGrid(true), 100);
        }
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [isMobile]);
  
  return (
    <div className="relative min-h-screen">
      {/* Flickering Grid Background - Deferred for better TTI */}
      {!isMobile && showGrid && (
        <FlickeringGrid
          className="fixed inset-0 z-0 pointer-events-none select-none"
          squareSize={3}
          gridGap={8}
          color="hsl(var(--muted-foreground))"
          maxOpacity={0.08}
          flickerChance={0.03}
        />
      )}
      
      {/* Content */}
      <div className="relative z-10">
        <div id="top" aria-hidden="true"></div>
        {children}
      </div>
    </div>
  );
};